import { render, staticRenderFns } from "./CustomizeMetalAN.vue?vue&type=template&id=6554e0c4&scoped=true"
import script from "./CustomizeMetalAN.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAN.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAN.vue?vue&type=style&index=0&id=6554e0c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6554e0c4",
  null
  
)

export default component.exports